import React from 'react';
import Box from 'core/ui/Box';
import { useTranslation } from 'react-i18next';
import SelectBoxObject from 'core/ui/SelectBoxObject';
import { Tag } from 'core/ui/ChosenComponents';
import FiltersMembers from './FiltersMembers';

const FiltersTypesMembers = ({ index, channelId, values, onChangeFiltersValues, excludeTypes }) => {
  const { t } = useTranslation();

  const onRemoveCustomUsers = (user) => {
    const users = values.filtersCustomUsers.filter((x) => x?.id !== user?.id);

    onChangeFiltersValues(index, { filtersCustomUsers: users });
  };

  return (
    <Box display="flex" className="gap-5" alignItems="flex-start">
      <Box flex={1}>
        <SelectBoxObject
          placeholder={t('placeholder.workflows.filters')}
          emptyItem
          options={[
            { id: 'member_types', name: t('label.memberTypes') },
            { id: 'member_tags', name: t('label.memberTags') },
            { id: 'memberships_tags', name: t('label.membershipsTags') },
            { id: 'class_registration', name: t('label.classRegistration') },
            { id: 'custom_users', name: t('label.selectUsers') },
          ].filter((x) => values?.filterType === x.id || !excludeTypes?.find((y) => y === x.id))}
          value={values?.filterType}
          setValue={(v) => onChangeFiltersValues(index, { filterType: v })}
          bordered
        />

        {values?.filtersCustomUsers && (
          <Box display="flex" className="gap-5" flexWrap="wrap" mt={2}>
            {values?.filtersCustomUsers?.map((item) => (
              <Box key={item?.id}>
                <Tag label={item?.name} onDelete={() => onRemoveCustomUsers(item)} />
              </Box>
            ))}
          </Box>
        )}
      </Box>

      <FiltersMembers
        channelId={channelId}
        index={index}
        onChangeFiltersValues={onChangeFiltersValues}
        values={values}
      />
    </Box>
  );
};

export default FiltersTypesMembers;
